import React , {useState, useEffect, useRef, memo, useCallback} from 'react';
import { View, StyleSheet, Text } from 'react-native';

import LoadingWheel from '../LoadingWheel';
import Modal from './Modal';
import GlobalPressable from '../button/GlobalPressable';

import { ALERT_TYPES } from '../../../constants/UIConstants';
import { COLORS, FONTS, FONT_SIZES } from '@bcm/constants';
import commonStyles, { defaultBorder, defaultMargin, defaultPadding } from '../styles/common';


const Alert = (props) => {

	const [isLoading, setIsLoading] = useState(false);
	const isMounted = useRef(false);

	const onCancel = useCallback( async () => {
		setIsLoading(true);
		if(props.onCancel) await props.onCancel();
		if(isMounted) setIsLoading(false);
		props.setAlertVisible(!props.alertVisible);
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props.alertVisible]);

	useEffect(() => {
		isMounted.current = true;
		return () => isMounted.current = false;
	}, []);

	return(
		<Modal
			modalVisible={props.alertVisible}
			setModalVisible={props.setAlertVisible}
			onCancel={onCancel}
		>
			<View style={styles.container}>
				<GlobalPressable style={styles.alertCard}>
					<View style={styles.header}>
						<Text style={[
							styles.headerText,
							{ fontFamily: (props.alertType === ALERT_TYPES.reconnect) ? FONTS.default : FONTS.bold }
						]}>
							{props.title ? props.title : 'Alert'}
						</Text>
					</View>
					{props.children && <View style={styles.body}>
						{props.children}
					</View>}
					{!props.hideButtons && <View style={styles.footer}>
						{isLoading && <LoadingWheel/>}
						{!isLoading && !props.isNotification && <GlobalPressable
							style={[styles.button, styles.buttonOnCancel]}
							onPress={onCancel}
						>
							<Text style={styles.buttonText}>{(props.onCancelText) ? props.onCancelText : 'CLOSE'}</Text>
						</GlobalPressable>}
						{!isLoading && <GlobalPressable
							style={[
								styles.button,
								{ backgroundColor: props.alertType === ALERT_TYPES.delete ? COLORS.textError : COLORS.primary }
							]}
							onPress={async () => {
								if(props.onSubmit) {
									setIsLoading(true);
									await props.onSubmit();
									setIsLoading(false);
								}
								props.setAlertVisible(!props.alertVisible);
							}}
							disabled={props.isDisabled}
						>
							<Text style={styles.buttonText}>{(props.onSubmitText) ? props.onSubmitText : 'OK'}</Text>
						</GlobalPressable>}
					</View>}
				</GlobalPressable>
			</View>
		</Modal>
	);
};

const styles = StyleSheet.create({
	container: {
		alignItems: 'center',
	},
	alertCard: {
		justifyContent: 'center',
		alignItems: 'center',
		backgroundColor: COLORS.light,
		...commonStyles.shadow,
	},
	header: {
		borderTopRightRadius: defaultBorder,
		borderTopLeftRadius: defaultBorder,
		padding: defaultPadding,
		alignItems: 'center',
	},
	headerText: {
		fontSize: FONT_SIZES.xl,
	},
	body: {
		width: '100%',
		padding: defaultPadding,
	},
	footer: {
		borderBottomRightRadius: defaultBorder,
		borderBottomLeftRadius: defaultBorder,
		padding: defaultPadding,
		flexDirection: 'row',
		justifyContent: 'space-evenly',
	},
	button: {
		justifyContent: 'center',
		alignItems: 'center',
		minWidth: 100,
		paddingVertical: defaultPadding / 2,
		paddingHorizontal: defaultPadding,
		marginHorizontal: defaultMargin,
		...commonStyles.shadow,
	},
	buttonOnCancel: {
		backgroundColor: COLORS.medium,
	},
	buttonText: {
		fontFamily: FONTS.bold,
		color: COLORS.white,
		fontSize: FONT_SIZES.lg,
	},
});

export default memo(Alert);